import { observer } from "mobx-react";
import * as React from "react";
import { Button, FormGroup, InputGroup } from "@blueprintjs/core";
import { observable } from "mobx";
import { MDBCol, MDBRow } from "mdbreact";
import { LoginStore } from "../../stores/login/LoginStore";
import { GenerateStore } from "../../stores/2fa/GenerateStore";
import { toast } from "react-toastify";

interface Props {
  email: string
  password: string
  token: string
}

@observer
export class Auth2faPage extends React.Component<Props, {}> {
  obs = observable({
    email: "" as string,
    password: "" as string,
    code: "" as string,
    loading: false as boolean
  })

  constructor(props: any) {
    super(props);
    this.obs.email = props.email
    this.obs.password = props.password
  }


  handleAccess = async () => {
    this.obs.loading = true

    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    if (!regex.test(this.obs.email)) {
      toast.warning("E-mail inválido!", {});
      this.obs.loading = false
      return
    }

    if (this.props.token == "") {
      await LoginStore.handleValidateCode(this.obs.code, this.obs.email, this.obs.password)
    } else {
      await LoginStore.handleValidateCodeAdmin(this.obs.code, this.obs.email, this.obs.password, this.props.token)
    }

    this.obs.loading = false
  }

  handleReturnLogin() {
    GenerateStore.obs.open2fa = false
  }

  handleSearchOnKeyEnter(e) {
    if (e.key === 'Enter') {
      this.handleAccess()
    }
  }

  render() {

    return (
      <>
        <div className="container-fluid container-login">
          <MDBRow>
            <MDBCol md="6" className="form-login" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
              <div className="login-img">
                <img src="/images/logo-novo.png" className="img-responsive" />
              </div>

              <h3 className="title-login" style={{ textAlign: "center" }}>Acesso ao Sistema</h3>

              <FormGroup
                className="form-group"
                label="Dupla Autenticação">
                <InputGroup type="text" onChange={(e: any) => this.obs.code = e.target.value} className="input-email" placeholder="Digite o código" onKeyPress={this.handleSearchOnKeyEnter.bind(this)} />
              </FormGroup>

              <div className="actions-form" style={{ marginBottom: 20 }}>
                <div style={{ display: "flex", marginLeft: -15, marginRight: -15 }}>
                  <MDBCol md="4"></MDBCol>

                  <MDBCol md="4">
                    <Button className="btn btn-voltar" onClick={() => this.handleReturnLogin()}>Voltar</Button>
                  </MDBCol>

                  <MDBCol md="4">
                    {!this.obs.loading
                      ? <Button className="btn btn-login" onClick={() => this.handleAccess()} onKeyPress={this.handleSearchOnKeyEnter.bind(this)}>Validar</Button>
                      : <Button className="btn btn-login">
                        <i className="fa fa-spinner fa-spin"></i>
                        Validando
                      </Button>
                    }
                  </MDBCol>
                </div>
              </div>

              <div style={{ textAlign: "center", fontSize: 15, marginTop: "auto", marginBottom: 20 }}>
                <div className="name-ent">Gerenciador Fiscal e Tributário Ltda.</div>
                <div>© 2023 . Todos os Direitos Reservados.</div>
              </div>

            </MDBCol>

            <MDBCol md="6" className="fundo-login">
              <div className="fundo-bg"></div>
            </MDBCol>

          </MDBRow>

        </div>
      </>
    );
  }
}

export default Auth2faPage;
